export default "__VITE_ASSET__D7Pvb5nG__"